import React from "react";
import { GeoData, OptionProps } from "./types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/pro-solid-svg-icons/faChevronRight";

import styles from "./DropdownOption.module.scss";
export const DropdownOption: React.FC<OptionProps> = props => {
    const { innerProps, getStyles, data } = props;
    const _data = data as GeoData;

    return (
        <div
            style={{
                ...getStyles("option", props),
                cursor: "pointer"
            }}
            className={styles.option}
            {...innerProps}
        >
            <span className={styles.optionContainer}>{_data.name}</span>
            <div className={styles.optionContainerExtraContent}>{_data?.provider?.name}</div>
            <div className={styles.optionContainerArrow}>
                <FontAwesomeIcon icon={faChevronRight} />
            </div>
        </div>
    );
};

export const ProviderDropdownOption: React.FC<OptionProps> = props => {
    const { innerProps, getStyles, data } = props;
    const _data = data as GeoData;

    return (
        <div
            style={{
                ...getStyles("option", props),
                cursor: "pointer"
            }}
            className={styles.option}
            {...innerProps}
        >
            <span className={styles.optionContainer}>{_data.name}</span>
            <div className={styles.optionContainerArrow}>
                <FontAwesomeIcon icon={faChevronRight} />
            </div>
        </div>
    );
};
